import * as actionTypes from "./actionTypes";
import admSvc from "../../axios-admsvc";
import { FETCH_REPORT_SEARCH_RESULT } from "../../shared/ApplicationUrls";

export const reportSearch = (searchCriteria) => {
  return (dispatch) => {
    dispatch(reportSearchSpinner(true));
    admSvc
      .post(FETCH_REPORT_SEARCH_RESULT, searchCriteria)
      .then((response) => {
        let searchResults = response.data.payload;
        if (
          response.data.status.code === "200" &&
          response.data.payload.status !== "failure"
        ) {
          dispatch(reportSearchSucess(searchResults));
          dispatch(isReportSearched(true));
        } else {
          dispatch(reportNotFoundErrorHandler());
        }
        dispatch(reportSearchSpinner(false));
      })
      .catch((error) => {
        if (error.toString().includes("404")) {
          dispatch(reportNotFoundErrorHandler(error));
        } else {
          dispatch(reportSearchException(error));
        }
        dispatch(reportSearchFailureResponse());
        dispatch(reportSearchSpinner(false));
      })
      .then((res) => {
        //to handle exception
      });
  };
};

export const resetSearchReports = () => {
  return {
    type: actionTypes.RESET_SEARCH_REPORTS
  }
}

export const setSearchState = (formData) => {
  return {
    type: actionTypes.REPORT_SEARCH_STATE,
    response: formData,
  };
};

export const setError = (error) => {
  return {
    type: actionTypes.SET_ERROR,
    error: error,
  };
};

export const reportSearchSucess = (data) => {
  return {
    type: actionTypes.SEARCH_REPORTS,
    response: data,
  };
};

export const reportSearchFailureResponse = () => {
  return {
    type: actionTypes.SEARCH_REPORTS,
    response: [],
  };
};

export const reportSearchException = (error) => {
  return {
    type: actionTypes.SEARCH_REPORT_FAILURE,
    error: error,
  };
};

export const reportNotFoundErrorHandler = (error) => {
  return {
    type: actionTypes.SEARCH_REPORT_NOT_FOUND,
    error: error,
  };
};

export const isReportSearched = (boolValue) => {
  return {
    type: actionTypes.IS_REPORT_SEARCHED,
    response: boolValue,
  };
};

export const reportSearchSpinner = (showSpinner) => {
  return {
    type: actionTypes.REPORT_LOAD_SPINNER,
    response: showSpinner,
  };
};
